import {LanguageSwitcherItemConfiguration} from '../../../app-bootstrap/config-interfaces/b2c-startup.configurations';
import {IServiceFactoryExtended} from '../../service-factory-extended.interface';
import {Check} from '@sparkware/app-utils';
import {ILanguageSwitcherItem} from './language-switcher-item.interface';

export class LanguageSwitcherItem implements ILanguageSwitcherItem {
  constructor(private _config: LanguageSwitcherItemConfiguration, private services: IServiceFactoryExtended) {
  }

  get title(): string {
    return this._config.title;
  }

  get url(): string {
    return this._config.url;
  }

  get isCurrent(): boolean {
    return false;
  }

  makeCurrent(): void {
    this.services.analytics.sendOrbitUserFlowEvent('Navigation','Language', this.title);

    this._executeOnClickJs();
    let url = this._config.url;

    if(this.services.device.hybrid.isEmbedded) {
      this.services.window.openSelf(url);
    } else {
      this._createCookie().then(() => {
        this.services.user.logout();
        setTimeout(() => {
          if(this._config.sendFunnelParameters) {
            url = this.services.marketing.appendSCutToUrl(url);
          }
          this.services.window.openSelf(url);
        }, 200);
      })
    }
  }

  private _createCookie(): Promise<void> {
    if(this.services.user.isAuthorized) {
      return this.services.user.getAutoLoginToken()
        .then(token => {
          this.services.cookies.createDomainCookie('orbit_autologin_token', token);
        }).catch(() => {
          this.services.logger.error('Failed to get autologin token in order to switch language');
        });
    } else {
      return Promise.resolve();
    }
  }

  private _executeOnClickJs(): void {
    try {


      if (!this._config.onClickJs) {
        return;
      }

      if (!Check.isString(this._config.onClickJs)) {
        this.services.logger.error(`onClickJs is not a string for language switcher item ${this.title}`);
        return;
      }

      if (this._config.onClickJs.length > 50) {
        this.services.logger.error(`Too long callback method for language switcher item ${this.title} click event: ${this._config.onClickJs.substring(0, 50)} ...`);
        return;
      }

      // eslint-disable-next-line
      let func = new Function(this._config.onClickJs);
      func();
    }
    catch (err) {
      this.services.logger.error(`Failed to execute onClickJs for language swithcer item ${this.title}; onClickJs: ${this._config.onClickJs}`, err);
    }
  }
}


